export default {
  aboutPage: {
    heroAlt: '华晟育林 HSYL',
    intro: [
      '我们建立中国本土常模数据，研发兼具专业性与本土适配性的评估量表工具与技术服务方案，',
      '致力于成为医疗、教育、科研等专业机构可信赖的长期合作伙伴，',
      '全方位助力健康筛查、临床诊疗康复、人才教育培养、个体潜能开发与国民心理健康发展。'
    ],
    valuesTitle: '我们践行的价值观',
    values: [
      { title: '深耕', desc: '专注于评估量表引进、本土化修订，\n建立标准化常模，筑牢专业根基。' },
      { title: '笃行', desc: '秉持科研初心，恪守行业规范，\n践行量表研发与专业服务。' },
      { title: '致远', desc: '立足行业长远发展，惠及社会民生，\n谋长久之业，行稳而致远。' }
    ],
    statements: [
      { title: '愿景', desc: '以专业力量助力个体成长，\n构筑中国评估量表新生态，\n致力于成为享誉国际、引领行业革新的标杆企业。' },
      { title: '使命', desc: '以专业赋能客户，以公益回馈社会。' }
    ]
  },
  socialPage: {
    heroAlt: '我们肩负的社会责任',
    title: '我们肩负的社会责任',
    topics: ['尊重员工', '守法经营', '服务客户', '投身公益'],
    bodies: [
      '尊重员工人格，为员工提供公平、公正、公开的工作环境是发展员工的最基本前提，育林反对任何形式的用工\n歧视，积极为员工提供安全、卫生、舒适、无干扰的工作环境以及适合当地消费水平的合理薪酬和法定福利。\n在帮助员工提升个人能力和职业竞争力的同时，实现员工和公司的共同进步；',
      '在商业活动中严格遵守国内外法律和国际公约，反对腐败，恪守诚信，并教导员工遵纪守法；',
      '秉承“以专业的技术和服务为客户和社会创造价值”的理念，立足于中国市场，以优质的产品和热忱的服务赢\n得客户信赖，持续提升客户满意度，做客户的亲密伙伴；',
      '华晟育林尊重合作伙伴所在国家或地区的法律法规、政治制度、宗教信仰和风俗习惯，并向合作伙伴支付与其\n所提供产品或服务等值的酬金，与合作伙伴分享适当信息，保守合作伙伴商业机密；\n华晟育林在实现自身快速成长的同时，也始终关注并投身于社会公益事业的发展，积极开展并参加/资助特殊儿\n童的教育和康复相关公益活动，推动和平、和谐社会的建立。'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/i18n/locales/zh/about.js